export enum ThumbnailType {
    HD_PREVIEW = 2,
}
